"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const chineseKendoStrings = __importStar(require("./kendo-strings/zh-CN.json"));
const enau = __importStar(require("./en-AU.json"));
const engb = __importStar(require("./en-GB.json"));
const ennz = __importStar(require("./en-NZ.json"));
const enus = __importStar(require("./en-US.json"));
const enza = __importStar(require("./en-ZA.json"));
const esmx = __importStar(require("./es-MX.json"));
const frca = __importStar(require("./fr-CA.json"));
const frenchKendoStrings = __importStar(require("./kendo-strings/fr-CA.json"));
const frfr = __importStar(require("./fr-FR.json"));
const jajp = __importStar(require("./ja-JP.json"));
const spanishKendoStrings = __importStar(require("./kendo-strings/es-ES.json"));
const index_1 = require("../index");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
index_1.loadLanguageJSON("en-US", enus);
index_1.loadLanguageJSON("en-GB", engb);
index_1.loadLanguageJSON("en-ZA", enza);
index_1.loadLanguageJSON("en-NZ", ennz);
index_1.loadLanguageJSON("en-AU", enau);
index_1.loadLanguageJSON("es-MX", esmx);
index_1.loadLanguageJSON("fr-CA", frca);
index_1.loadLanguageJSON("fr-FR", frfr);
index_1.loadLanguageJSON("ja-JP", jajp);
kendo_react_intl_1.loadMessages(spanishKendoStrings, "es");
kendo_react_intl_1.loadMessages(frenchKendoStrings, "fr");
kendo_react_intl_1.loadMessages(chineseKendoStrings, "ja"); // Should be replaced with Japanese if/when it becomes available at https://github.com/telerik/kendo-react-messages/tree/master/messages
//# sourceMappingURL=loadLanguageData.js.map